import { combineReducers } from "redux";
import { all } from "redux-saga/effects";

import twitterReducer from "./twitter";

import { authReducer as auth } from "./auth/auth.duck";
import { commentsReducer as comments, commentsSaga } from "./comments"

const rootReducer = combineReducers({
  auth,
  user: auth,
  twitter: twitterReducer,
  comments
});

function* rootSaga() {
  yield all([
    commentsSaga()
  ]);
}

export { rootSaga, rootReducer };
